import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faPlus,
  faQrcode,
  faRefresh,
  faRankingStar,
  faMagnifyingGlass,
  faPenToSquare,
  faDatabase,
  faClapperboard,
  faMicrophone,
  faListOl,
  faCog,
  faAngleLeft,
  faCircleStop,
  faChartDiagram,
  faCircleExclamation,
  faList,
  faIndustry,
  faStopwatch,
  faGaugeHigh,
  faCheckDouble,
  faSackDollar,
  faScaleBalanced,
  faClockRotateLeft,
  faClipboardCheck,
  faArrowUp,
  faArrowDown,
  faLanguage,
  faClone,
  faFloppyDisk,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFilePdf,
  faFileWord,
  faFileExcel,
  faFileVideo,
  faFileAudio,
  faFilePowerpoint,
  faFile,
  faRectangleList,
} from "@fortawesome/free-regular-svg-icons";

export function useIcons() {
  library.add(faPlus);
  library.add(faQrcode);
  library.add(faPenToSquare);
  library.add(faMagnifyingGlass);
  library.add(faRankingStar);
  library.add(faDatabase);
  library.add(faRefresh);
  library.add(faClapperboard);
  library.add(faMicrophone);
  library.add(faCog);

  library.add(faListOl);
  library.add(faList);
  library.add(faCircleStop);
  library.add(faAngleLeft);
  library.add(faChartDiagram);
  library.add(faCircleExclamation);

  library.add(faIndustry);
  library.add(faStopwatch);
  library.add(faGaugeHigh);
  library.add(faCheckDouble);
  library.add(faSackDollar);
  library.add(faScaleBalanced);
  library.add(faClockRotateLeft);
  library.add(faClipboardCheck);
  library.add(faArrowUp);
  library.add(faArrowDown);
  library.add(faLanguage);
  library.add(faClone);
  library.add(faFloppyDisk);

  library.add(faFilePdf);
  library.add(faFileWord);
  library.add(faFileExcel);
  library.add(faFileVideo);
  library.add(faFileAudio);
  library.add(faFilePowerpoint);
  library.add(faFile);
  library.add(faRectangleList);
}
